// extracted by mini-css-extract-plugin
module.exports = {"diagnoses":"_DiagnosesDialog_diagnoses__3zvGJ","diagnose":"_DiagnosesDialog_diagnose__4z4Fv","delete":"_DiagnosesDialog_delete__3GJiV"};